__turbopack_context__.v({
  "imageFooter": "image-prize-vote-2023-module-scss-module__S8rNWW__imageFooter",
  "responsiveButton": "image-prize-vote-2023-module-scss-module__S8rNWW__responsiveButton",
  "votingBox": "image-prize-vote-2023-module-scss-module__S8rNWW__votingBox",
});
